import { CABINET_PATHS, CABINET_PLATFORM, CabinetAppVersionComponent } from '@nebalkon-workspace/cabinet-core';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { AuthService, ProfileService, UserRole } from '@nebalkon-workspace/auth';

@Component({
  selector: 'lib-staff-settings',
  imports: [TranslatePipe, CabinetAppVersionComponent],
  templateUrl: './staff-settings.component.html',
  styleUrl: './staff-settings.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StaffSettingsComponent {
  readonly embeddedInCabinetPage = input(false);

  readonly #cabinetPaths = inject(CABINET_PATHS);
  protected readonly staffCabinetPath = this.#cabinetPaths.staff;
  readonly #router = inject(Router);
  readonly #authService = inject(AuthService);
  readonly #profileService = inject(ProfileService);
  readonly #platform = inject(CABINET_PLATFORM);

  protected readonly isWeb = this.#platform === 'web';
  protected readonly canEditMyEmployeeProfile =
    this.#authService.roles().includes(UserRole.Admin);

  protected goToPrinters(): void {
    void this.#router.navigate([this.#cabinetPaths.staff, 'settings', 'printers']);
  }

  protected goToClient(): void {
    void this.#router.navigateByUrl(this.#cabinetPaths.client);
  }

  protected goToMyEmployeeProfile(): void {
    const myId = this.#profileService.userInfo()?.user.id;
    if (!myId) {
      return;
    }
    void this.#router.navigate([this.#cabinetPaths.staff, 'employees', myId, 'edit']);
  }

  protected logout(): void {
    this.#authService.logout(this.#platform === 'web' ? '/' : undefined);
  }
}
